export default "__VITE_ASSET__BgwUZZTv__"